import Vue from 'vue';
import { mapGetters } from 'vuex';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { cognitoMixins } from '@storm/mixins/cognito';

export default Vue.component('storm', {
  template: require('./template.html'),
  name: 'storm',
  mixins: [cognitoMixins],
  computed: {
    ...mapGetters(['stormPool']),
  },
  created() {
    this.getUserPool();
  },
  methods: {
    async getUserPool() {
      if (!this.stormPool) {
        const userPool = new CognitoUserPool({
          UserPoolId: process.env.STORM_USER_POOL_ID,
          ClientId: process.env.STORM_CLIEND_ID,
        });
        this.$store.dispatch('setStormPool', userPool);
      }
      await this.signOutDrzzleUser();
    },
    async signOutDrzzleUser() {
      try {
        await this.forceDrzzleLogout();
      } catch (e) {
        this.$log.warn(e);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/index.js